import React, { useEffect } from 'react';
import appointmentSelectors from 'features/appointment/services/selectors';
import { useAppDispatch } from 'store/hooks';
import appointmentActions from 'features/appointment/services/actions';
import SelectStaff from 'components/SelectStaff';
import { CALENDAR_VIEW_TYPE } from 'features/appointment/services/constants';

const SortingStaffSelected = () => {
  const dispatch = useAppDispatch();
  
  const viewType = appointmentSelectors.getViewType();

  useEffect(() => {
    return () => {
      dispatch(appointmentActions.setStaffFilter(null));
    };
  }, []);

  if (viewType === CALENDAR_VIEW_TYPE.DAY_VIEW) {
    return (
      <div >
        <SelectStaff />
      </div>
    );
  }
  return <div></div>;
};

export default SortingStaffSelected;
